<template>
  <ParagraphBody
    v-if="readonly"
    :data-test-id="dataTestId"
  >
    {{ permissionsDisplayName }}
  </ParagraphBody>
  <Select
    v-else
    v-bind="$attrs"
    :data-test-id="dataTestId"
    helperText="[Learn more](https://support.jumpcloud.com/s/article/JumpCloud-Roles) about roles."
    isHelperTextMarkdown
    :options="permissions"
    :value="value"
    @input="handleInput"
  />
</template>

<script>
import {
  ParagraphBody,
  Select,
} from '@jumpcloud/ui-components';
import { mapState } from 'vuex';

const settingsModule = 'SettingsModule';

// Priorities for Roles from most privileged to least.
// Smaller value indicates higher priority.
const rolePriorities = {
  'Administrator With Billing': 1,
  Administrator: 2,
  Manager: 3,
  'Command Runner With Billing': 4,
  'Command Runner': 5,
  'Help Desk': 6,
  'Read Only': 7,
  Unknown: 8,
};

export default {
  name: 'RoleSelect',

  components: {
    ParagraphBody,
    Select,
  },

  props: {
    dataTestId: {
      type: String,
      default: undefined,
    },
    readonly: Boolean,
    value: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    ...mapState(settingsModule, ['roles']),

    permissions() {
      // Priority sort the roles by the
      // corresponding rolePriorities values.
      const permissions = [...this.roles];
      permissions.sort((a, b) => {
        // If a or b have named without a defined priority, assign the Unknown
        // priority which will place the role last.
        const aPriority = rolePriorities[a.name] || rolePriorities.Unknown;
        const bPriority = rolePriorities[b.name] || rolePriorities.Unknown;

        if (aPriority < bPriority) {
          return -1;
        }

        // a should occur after b.
        if (aPriority > bPriority) {
          return 1;
        }

        return 0;
      });

      // eslint-disable-next-line no-underscore-dangle
      return permissions.map((role) => ({ name: role.name, value: role._id }));
    },

    permissionsDisplayName() {
      const displayName = this.value
        ? this.permissions.find(permission => permission.value === this.value).name
        : '';

      return displayName;
    },
  },

  methods: {
    handleInput(newValue) {
      this.$emit('input', newValue);
    },
  },
};
</script>

<style scoped module>
  .readonly.readonly {
    margin-bottom: var(--jc-spacer-medium);
  }
</style>
